import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetCustomerRepReport = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 50,
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
    search: '',
    sales_rep_type: '',
  }

  const {filters, onSearch, onSortingChange, onPageChange, onDateChange, setMultipleFilters} =
    useFilters(initialFilters, {sortType: 'number'})
  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/customer-reps', {
    queryId: 'customer-rep-report',
    filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeSalesRepTypeFilter = (values: any[]) => {
    setMultipleFilters({
      sales_rep_type: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    pagination: response?.meta?.pagination || {},
    onChangeSalesRepTypeFilter,
  }
}

export default useGetCustomerRepReport
